import { useRouter } from 'next/router'

import useSWR from 'swr'

import { serializeCacheKey } from '@/lib/contentful/utils'

import { Link } from '@/components/CustomLink'

import { getAllAppAlgoliaFacets } from '../AppSidebar/getAllAppFacets'

type Props = {
	className?: string
}

export function AppCategoryList({}: Props) {
	const { locale } = useRouter()

	const { data } = useSWR(serializeCacheKey('appAlgoliaFacets', { locale }), () =>
		getAllAppAlgoliaFacets()
	)

	if (!data) return null

	return (
		<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10 w-full">
			{data?.parentCategories?.map(
				(category: { title?: string; slug?: string; appCount?: number | string }, i: number) => {
					if (!category?.title) return null

					return (
						<Link
							href={`/apps/categories/${category.slug}/`}
							className="text-bc-blue font-medium"
							key={i}
						>
							{category.title}

							<span className="text-bc-black text-sm">{` (${category.appCount})`}</span>
						</Link>
					)
				}
			)}
		</div>
	)
}
